class Elem {
    /**
     * Get data from attributes
     * @param {HTMLButtonElement} elem
     * @return {DOMStringMap & {size: (string|string), name: string, location: Location | any}}
     */
    static getData(elem) {
        /** @type {string} */
        let name = elem.dataset.modal;

        if (!name) {
            throw new Error('The `name` of the modal window is not specified!');
        }

        /** @type {HTMLInputElement} */
        const inputRoute = document.getElementById('route');
        let route = {};

        if (inputRoute && Object.prototype.hasOwnProperty.call(inputRoute, 'value') && inputRoute.value !== '') {
            route = {route: inputRoute.value};
        }

        return Object.assign(route, elem.dataset, {
            location: window.location,
            name,
            size: elem.dataset.modalSize ? elem.dataset.modalSize : '',
        });
    }
}

export default Elem;
